export default "__VITE_ASSET__CgaVQ1cX__"